import { render, staticRenderFns } from "./show-schedule-tile.vue?vue&type=template&id=0a2bfca3"
import script from "./show-schedule-tile.vue?vue&type=script&lang=js"
export * from "./show-schedule-tile.vue?vue&type=script&lang=js"
import style0 from "./show-schedule-tile.vue?vue&type=style&index=0&id=0a2bfca3&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports